import axios from 'axios';

export default {
    methods: {
        async saldoSb2(d, ok, err) {
            try {
                let r = await axios.post('stock/saldo/sb2', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/stock/saldos.js